import React, {Component} from 'react';
import {connect} from 'react-redux';

import Box from 'components/box';
import {RatingDetailList} from './rating-detail-list';
import Textarea from 'form/textarea';
import {ButtonDefault} from 'components/buttons';
import {Divider} from 'components/common';

import {loadRatingDetail, addAnswerToRating} from 'redux/actions/portal/institutions';

const mapStateToProps = state => ({
  rating: state.institutions.get('ratingDetail'),
});

const mapDispatchToProps = dispatch => ({
  onLoad: (id) => dispatch(loadRatingDetail(id)),
  onAnswerChange: (id, answer) => dispatch(addAnswerToRating(id, answer))
});

class RatingDetail extends Component {

  state = {
    comment: ""
  }

  changeComment = event => {
    this.setState({comment: event.target.value});
  }

  onSubmitComment = () => {
    this.props.onAnswerChange(this.props.match.params.rating_id, this.state.comment)
    // this.setState(() => ({ comment: ''}))
  }

  componentDidMount() {
    this.props.onLoad(this.props.match.params.rating_id);
  }

  componentWillReceiveProps (nextProps) {
    if(nextProps.rating){
      const answer = nextProps.rating.get('answer')
      this.setState(() => ({comment: answer}))
    }
  }

  render() {

    if (this.props.rating === undefined) return null;

    return(
      <div>
        <Box title3="Інформація про оцінку лікарю">
          <RatingDetailList rating={this.props.rating} />
          {this.props.rating.get('answer') &&
            <Divider>
              <p>Коментар до відповіді: <strong>{this.props.rating.get('answer')}</strong></p>
            </Divider>
          }
          <Divider>
            <Textarea
              block
              label="Коментар до відповіді"
              value={this.state.comment ? this.state.comment : ""}
              onChange={this.changeComment}
              placeholder="Введіть коментар до відповіді"
            />
          </Divider>
          <Divider>
            <ButtonDefault
              value="Додати"
              onClick={this.onSubmitComment}
            />
          </Divider>
        </Box>
      </div>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(RatingDetail);



// WEBPACK FOOTER //
// ./src/administration/rating/detail.js